import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/calc-dims/create')({
  beforeLoad: () => getTitleContextSlice('Create Calculated Dimension'),
});
